module.exports = __webpack_public_path__ + "static/media/slim-preto.60e094f7.webp";